/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_TitleInputs */

const en_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Without the Grind`)
};

const es_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juega sin desgaste`)
};

const de_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Verschleiß spielen`)
};

const zh_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打球不必伤身`)
};

const ar_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العب دون الإرهاق`)
};

const fr_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouez sans stress`)
};

const vi_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi không hao mòn`)
};

const sw_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheza Bila Kuuchosha Mwili`)
};

const th_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นได้โดยไม่ต้องทรมานร่างกาย`)
};

const bs_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igraj bez istrošenosti`)
};

const ja_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無理なくプレーする`)
};

const ko_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무리 없이 플레이하기`)
};

const pt_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogue sem desgaste`)
};

const it_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioca senza logorarti`)
};

const sv_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spela utan slitage`)
};

const nl_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel zonder slijtage`)
};

const da_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil uden slid`)
};

const nb_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill uten slitasje`)
};

const fi_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaa kuluttamatta itseäsi`)
};

const pl_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graj bez przeciążeń`)
};

const ru_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играйте без износа`)
};

const tr_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıpranmadan oynayın`)
};

const hi_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिना थकान के खेलें`)
};

const id_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain Tanpa Membebani Tubuh`)
};

const ms_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain Tanpa Membebankan Tubuh`)
};

const cs_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hrajte bez opotřebení`)
};

const el_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παίξτε χωρίς φθορά`)
};

const he_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שחקו בלי להישחק`)
};

const af_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel sonder die slytasie`)
};

const hu_method_content_step_06_title = /** @type {(inputs: Method_Content_Step_06_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játssz kíméletesen`)
};

/**
* | output |
* | --- |
* | "Play Without the Grind" |
*
* @param {Method_Content_Step_06_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_title = /** @type {((inputs?: Method_Content_Step_06_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_title(inputs)
	if (locale === "de") return de_method_content_step_06_title(inputs)
	if (locale === "zh") return zh_method_content_step_06_title(inputs)
	if (locale === "ar") return ar_method_content_step_06_title(inputs)
	if (locale === "fr") return fr_method_content_step_06_title(inputs)
	if (locale === "vi") return vi_method_content_step_06_title(inputs)
	if (locale === "sw") return sw_method_content_step_06_title(inputs)
	if (locale === "th") return th_method_content_step_06_title(inputs)
	if (locale === "bs") return bs_method_content_step_06_title(inputs)
	if (locale === "ja") return ja_method_content_step_06_title(inputs)
	if (locale === "ko") return ko_method_content_step_06_title(inputs)
	if (locale === "pt") return pt_method_content_step_06_title(inputs)
	if (locale === "it") return it_method_content_step_06_title(inputs)
	if (locale === "sv") return sv_method_content_step_06_title(inputs)
	if (locale === "nl") return nl_method_content_step_06_title(inputs)
	if (locale === "da") return da_method_content_step_06_title(inputs)
	if (locale === "nb") return nb_method_content_step_06_title(inputs)
	if (locale === "fi") return fi_method_content_step_06_title(inputs)
	if (locale === "pl") return pl_method_content_step_06_title(inputs)
	if (locale === "ru") return ru_method_content_step_06_title(inputs)
	if (locale === "tr") return tr_method_content_step_06_title(inputs)
	if (locale === "hi") return hi_method_content_step_06_title(inputs)
	if (locale === "id") return id_method_content_step_06_title(inputs)
	if (locale === "ms") return ms_method_content_step_06_title(inputs)
	if (locale === "cs") return cs_method_content_step_06_title(inputs)
	if (locale === "el") return el_method_content_step_06_title(inputs)
	if (locale === "he") return he_method_content_step_06_title(inputs)
	if (locale === "af") return af_method_content_step_06_title(inputs)
	if (locale === "hu") return hu_method_content_step_06_title(inputs)
	return en_method_content_step_06_title(inputs)
});